import type { Mutation } from 'vuex'
import type { CorpParams, State } from './state'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_DIRECT_CORP_DETAIL]: (state: State, item: any) => {
    state.detail = [...item]
  },

  [actionTypes.SET_PARAMS]: (state: State, item: CorpParams) => {
    state.params = { ...item }
  },

  [actionTypes.SET_TOTAL_COUNT]: (state: State, count: number) => {
    state.total_count = count
  },
}

export default mutations
